var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.$global.isMobileDevice())?_c('div',{staticClass:"wp-block-spacer",staticStyle:{"height":"55px"},attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }